import React, { useState } from "react";
import RaindropMotionFadeDown from "../raindrop-motion-fade-down/raindrop-motion-fade-down.tsx";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";

const QuestionAndAnswer = ({ id, question, answer }) => {
  const [isSelected, setIsSelected] = useState(false);

  const iconRotation = isSelected ? "rotate-90" : "rotate-0";

  return (
    <RaindropCard
      onClick={() => setIsSelected(!isSelected)}
      additionalClasses="flex flex-col gap-2"
    >
      <div className="flex flex-row items-center text-left w-full">
        <h3 className="font-bold text-lg text-left pr-10">{question}</h3>

        <i
          className={`fas fa-chevron-right justify-center ml-auto  ${iconRotation} transition-all`}
        ></i>
      </div>

      {isSelected && (
        <RaindropMotionFadeDown className="text-left text-color-dark-text-secondary">
          {answer}
        </RaindropMotionFadeDown>
      )}
    </RaindropCard>
  );
};

const ContentFrequentlyAskedQuestions = () => {
  const questionsAndAnswers = [
    {
      question: "Why can't I find you on the App Store?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Eeek, we are not yet on there.</p>
          <p>
            Shortly we will be pushing to get Raindrop on the iOS and Android
            app store.
          </p>
          <p>
            For now, we are a webapp. To still have the app on your home screen,{" "}
            <a
              href="/raindrop/tip-add-to-home"
              className="font-bold text-color-raindrop-primary"
            >
              follow this guide.
            </a>
          </p>
        </div>
      ),
    },
    {
      question: "Do you take a cut of my donation?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Nope</p>
          <p>
            By default, all your money will go to your organisations (minus some
            pesky card fees for the payment provider.)
          </p>
          <p>
            Optionally, you can choose to move to a paid plan that will remove
            ads and give you some extra goodies. We will take a small percentage
            of your donation to support this, but your total contribution won't
            change. Pretty neat 💕
          </p>
        </div>
      ),
    },
    {
      question: "How do you make money?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Great question! 🐰</p>
          <p>
            We don't take a cut of your donation. However, if you choose to move
            to Raindrop Plus we do take a 10% proportion of your donate and you
            support our work as well as being able to donate to more
            organisations and remove ads.
          </p>
          <p>
            We make money by partnering with charities. Charities can give us
            money to become hydrated. This lets them build a richer profile in
            the app, post updates to their supporters, be listed higher in the
            search ranking and gives them access to anonymised data about their
            supporters.
          </p>
          <p>
            For example, we might tell them that 20% of your supports started
            supporting you in June.
          </p>
          <p>
            Organisations can also purchase some slick ad space. So, instead of
            plastering an ad on the side of a bus they can advertise on a
            platform to people who are actively looking to give money to great
            things!
          </p>
          <p>Pretty neat 💕</p>
        </div>
      ),
    },
    {
      question: "Can I make a one-off donation?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>
            Unfortunately, we don't currently let you make one-off donations.
          </p>
          <p>
            We're committed to doing right by our users and trying to help
            charities be as effective as possible. Charities prefer recurring
            donations because it helps them with long-term planning.
          </p>
          <p>And that's a good thing 🥕</p>
        </div>
      ),
    },
    {
      question: "Can I stop my donation at anytime?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Absolutely!</p>
          <p>
            We don't believe in locking you into a donation. We think more
            people will donate if they feel safe and in-control.
          </p>
          <p>
            You can stop your donation by going to the contributions page 💖
          </p>
        </div>
      ),
    },
    {
      question: "What is a Waterfall?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>
            Do you want to run a 5km to raise money for medical research? Let's
            do it.
          </p>
          <p>
            Create your Waterfall in the Raindrop app. Someone can then add your
            Waterfall to their Raindrop Circle to support you. Pretty cool, huh?
          </p>
          <p>
            Don't forget to keep posting updates to keep your supporters engaged
            😎
          </p>
        </div>
      ),
    },
    {
      question: "What is a hydrated organisation?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Great question!</p>
          <p>
            You'll notice that some organisations in the app have a little pink
            droplet icon next to their name. These are hydrated organisations.
          </p>
          <p>
            Hydrated organisations colloborate directly with Raindrop. They'll
            have a richer profile in the app and they'll post updates on the
            work they're doing.
          </p>
          <p>
            Legal disclosure: Currently, not all organisations with a pink
            droplet are working directly with us. We do hydrate some
            organisations for the purposes of testing and demoing 😅
          </p>
        </div>
      ),
    },
    {
      question: "Do you sell my personal data to charities?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Nope</p>
          <p>
            We give charities the bare minimum amount of data to help facilitate
            your donation.
          </p>
          <p>
            We do provide anonymised aggregated data to hydrated organisations
            to help them with planning and logistics. What does that mean? For
            example, we might tell the Shnoodle Trust charity that 20% of their
            supports are under 30 years old.
          </p>
          <p>Helpful, but anonymous 😎</p>
        </div>
      ),
    },
    {
      question: "Do you support Gift Aid?",
      answer: (
        <div className="flex flex-col gap-2">
          <p>Unfortunately, we do not currently support Gift Aid.</p>
          <p>... but watch this space 🤫</p>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-8 w-full">
      {questionsAndAnswers.map((qa, index) => (
        <QuestionAndAnswer
          key={index}
          id={index}
          question={qa.question}
          answer={qa.answer}
        />
      ))}
    </div>
  );
};

export default ContentFrequentlyAskedQuestions;
